module.exports = __webpack_public_path__ + "img/twiter-dist.142d6b42.svg";